/* swish-shelf.js — PDP "Also Available As" shelf + trust row + drop/cut-off countdown.
   Externalized from swish-product-info-shelf.v3.liquid to stay under Shopify's ~50KB
   per-block cap. The only Liquid-coupled values live in window.SWISH_SHELF_CONFIG,
   set by the inline bootstrap in the theme block. Loaded via
   <script src="{{ 'swish-shelf.js' | file_url }}" defer>. file_url cache-busts on each upload.
   Re-publish through the staged-upload + fileUpdate path (see config_update_process). */

/* killLabels block removed — was removing .js-label elements that variant-picker.js needs to update price text on variant change, breaking image swap. */

/* Cart drawer force-open hook.
   Theme setting theme.settings.afterAtc is "nothing" and the customizer doesn't surface
   a UI option to flip it. So we patch fetch + XHR to detect any successful POST to
   /cart/add(.js) and explicitly open the cart drawer ourselves after a short delay
   to let the theme finish its own cart refresh. Idempotent &mdash; calling open() on an
   already-open drawer is a no-op. */
(function() {
  try {
    var openDrawer = function() {
      setTimeout(function() {
        var cd = document.querySelector('cart-drawer');
        if (!cd) return;
        try { if (typeof cd.refresh === 'function') cd.refresh(); } catch (e) {}
        try { if (typeof cd.open === 'function') cd.open(); } catch (e) {}
      }, 250);
    };
    var isCartAdd = function(url) {
      if (!url) return false;
      var s = String(url);
      return /\/cart\/add(\.js)?(\?|$)/.test(s);
    };
    /* Patch fetch */
    if (window.fetch && !window.__swCartHookFetch) {
      window.__swCartHookFetch = true;
      var origFetch = window.fetch.bind(window);
      window.fetch = function(input, init) {
        var url = (typeof input === 'string') ? input : (input && input.url);
        var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        var promise = origFetch(input, init);
        if (isCartAdd(url) && method === 'POST') {
          promise.then(function(r) { if (r && r.ok) openDrawer(); }).catch(function(){});
        }
        return promise;
      };
    }
    /* Patch XMLHttpRequest */
    if (window.XMLHttpRequest && !window.__swCartHookXhr) {
      window.__swCartHookXhr = true;
      var origOpen = XMLHttpRequest.prototype.open;
      var origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function(method, url) {
        this.__swMethod = (method || '').toUpperCase();
        this.__swUrl = url;
        return origOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function() {
        if (this.__swMethod === 'POST' && isCartAdd(this.__swUrl)) {
          this.addEventListener('load', function() {
            if (this.status >= 200 && this.status < 300) openDrawer();
          });
        }
        return origSend.apply(this, arguments);
      };
    }
  } catch (e) { /* swallow &mdash; never break the page over this */ }
})();

(function() {
  /* JS-based Sezzle removal — more reliable than CSS hide for third-party app injections.
     Removes any Sezzle widget (theme block, app-embed inject, or any future variant) but
     never touches our own .sw-sezzle. Re-runs whenever new nodes are added to body. */
  try {
    /* Scoped to .product-info only &mdash; never touches the cart drawer, header, footer, etc.
       Also: only removes the Sezzle element itself, NEVER its parent .shopify-block,
       because walking up would nuke whatever shared section the block lives in. */
    var killSezzle = function() {
      var scope = document.querySelector('.product-info, .product__info, [class*="product-info"]');
      if (!scope) return;
      scope.querySelectorAll(
        '.sezzle-shopify-info-button, [class*="sezzlewidgetindex"], [class*="sezzle-checkout-button-wrapper"]'
      ).forEach(function(el) {
        if (el.closest('.sw-sezzle')) return; /* never our own */
        el.remove();
      });
    };
    killSezzle();
    var pdpScope = document.querySelector('.product-info, .product__info, [class*="product-info"]');
    if (window.MutationObserver && pdpScope) {
      new MutationObserver(killSezzle).observe(pdpScope, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', killSezzle);
    }
  } catch(e) {}
})();

(function() {
  // Custom Sezzle widget — replaces the malformed third-party render with our own
  // clean inline line. Clicking the (i) calls the original Sezzle widget's modal
  // trigger if available, falling back to opening sezzle.com in a new tab.
  try {
    var SEZZLE_LOGO = 'https://media.sezzle.com/branding/2.0/Sezzle_Logo_FullColor.svg';
    var build = function() {
      if (document.querySelector('.sw-sezzle')) return;
      var priceEl = document.querySelector('.product-info__price');
      if (!priceEl) return;
      var priceText = priceEl.textContent.replace(/[^0-9.,]/g, '').replace(/,/g, '');
      var amount = parseFloat(priceText);
      if (!amount || isNaN(amount)) return;
      var perPayment = (amount / 4).toFixed(2);
      var currencyMatch = priceEl.textContent.match(/[A-Z]{3}$/);
      var currency = currencyMatch ? currencyMatch[0] : '';
      var currencySymbol = priceEl.textContent.match(/[\$£€¥]/);
      currencySymbol = currencySymbol ? currencySymbol[0] : '$';
      var line = document.createElement('div');
      line.className = 'sw-sezzle';
      line.innerHTML = 'or 4 payments of <strong>' + currencySymbol + perPayment + (currency ? ' ' + currency : '') +
        '</strong> with <img src="' + SEZZLE_LOGO + '" alt="Sezzle" class="sw-sezzle-logo">' +
        '<button type="button" class="sw-sezzle-info" aria-label="How Sezzle works">&#9432;</button>';
      priceEl.parentNode.insertBefore(line, priceEl.nextSibling);
      line.querySelector('.sw-sezzle-info').addEventListener('click', function(e) {
        e.preventDefault();
        window.open('https://sezzle.com/how-it-works', '_blank', 'noopener');
      });
    };
    build();
    if (window.MutationObserver) {
      var priceEl2 = document.querySelector('.product-info__price');
      if (priceEl2) {
        new MutationObserver(function() {
          var existing = document.querySelector('.sw-sezzle');
          if (existing) existing.remove();
          build();
        }).observe(priceEl2, { childList: true, subtree: true, characterData: true });
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', build);
    }
  } catch(e) {}
})();
(function() {
  'use strict';
  function isLikelyBot() {
    try {
      if (window.Shopify && window.Shopify.designMode) return false;
      if (navigator.webdriver) return true;
      var ua = navigator.userAgent;
      if (/HeadlessChrome|PhantomJS|SlimerJS|Selenium|Puppeteer|Playwright/i.test(ua)) return true;
      if (!window.history || !document.querySelector || !document.addEventListener) return true;
      if (navigator.cookieEnabled === false) return true;
      if (window.screen.width === 0 || window.screen.height === 0) return true;
      if (document.visibilityState && document.visibilityState !== 'visible') return true;
      return false;
    } catch (e) { return false; }
  }
  if (isLikelyBot()) return;

  const CONFIG = window.SWISH_SHELF_CONFIG || {};

  // Lift the urgency info-icon opacity so the countdown tooltip trigger is readable.
  // Mirrors swish-pdp-styles.liquid; injected here so it ships without a theme paste.
  try {
    if (!document.getElementById('sw-shelf-inline-style')) {
      const st = document.createElement('style');
      st.id = 'sw-shelf-inline-style';
      st.textContent = '.sw-urgency-inline .sw-info-i{opacity:0.9 !important;}';
      document.head.appendChild(st);
    }
  } catch (e) { /* non-fatal */ }

  const CNY = {
    cottonKeys: ['cotton-long-sleeve-button-shirt', 'cotton-button-shirt'],
    seasonEnd: new Date('2026-02-19'),
    cutoffCotton: new Date('2026-01-31T23:59:59'),
    cutoffPoly:   new Date('2026-02-06T23:59:59'),
    resumeCotton: new Date('2026-02-24'),
    resumePoly:   new Date('2026-02-24')
  };

  const Engine = {
    isPostCutoff: false,
    applyFormat: function(v, isUpgradeLabel) {
      var discountEl = document.getElementById('global-sale-percentage');
      var discount = (discountEl && discountEl.value) ? parseFloat(discountEl.value) : 0;
      var rawFormat = decodeURIComponent(CONFIG.format);
      var formatMoney = function(cents) {
        var str = rawFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (cents/100).toFixed(2));
        var tmp = document.createElement("DIV"); tmp.innerHTML = str;
        return tmp.textContent || tmp.innerText || "";
      };
      if (discount > 0) {
        var originalPrice = formatMoney(v);
        var discountedValue = v * (1 - (discount / 100));
        var salePrice = formatMoney(discountedValue);
        if (isUpgradeLabel) return salePrice;
        return `<span style="color: #D8176A; font-weight: 900;">${salePrice}</span> <span style="text-decoration: line-through; color: #94a3b8; font-size: 0.85em; font-weight: 400; margin-left: 4px;">${originalPrice}</span>`;
      }
      return formatMoney(v);
    },
    getMkt: () => {
      const h = location.hostname.toLowerCase();
      const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'USD';
      if (h.includes('.ca') || cur === 'CAD') return 'CA';
      if (h.includes('.co.uk') || cur === 'GBP') return 'UK';
      if (h.includes('.eu') || cur === 'EUR') return 'EU';
      if (h.includes('australia') || cur === 'AUD') return 'AU';
      return 'US';
    },
    checkCutoff: (mkt) => {
      const h = { 'US':'America/Los_Angeles', 'CA':'America/Los_Angeles', 'UK':'Europe/London', 'EU':'Europe/Riga', 'AU':'Australia/Brisbane' };
      const tz = h[mkt] || h['US'];
      const now = new Date();
      const hubTime = new Date(now.toLocaleString("en-US", {timeZone: tz}));
      const cutoff = new Date(now.toLocaleString("en-US", {timeZone: tz}));
      cutoff.setHours(12, 0, 0, 0);
      return hubTime > cutoff;
    },
    addBD: (date, days) => {
      let result = new Date(date); let count = 0;
      while (count < days) {
        result.setDate(result.getDate() + 1);
        if (result.getDay() !== 0 && result.getDay() !== 6) count++;
      }
      return result;
    },
    AVAIL_KEY_MAP: {
      't-shirt': 'T-Shirt','tank-top': 'Tank Top','hoodie': 'Hoodie','sweatshirt': 'Sweatshirt',
      'triblend-t-shirt': 'Triblend T-Shirt','text-shirt': 'Text Shirt','boxy-t-shirt': 'Boxy T-Shirt',
      'mug': 'Mug','muscle-shirt': 'Muscle Shirt'
    },
    isAvailableForRequest: (v, mkt, availData) => {
      if (mkt === 'US') return true;
      if (!availData || !availData.products) return true;
      const availKey = Engine.AVAIL_KEY_MAP[v.key];
      if (!availKey) return true;
      const entry = availData.products[availKey];
      if (!entry) return true;
      const marketEntry = entry[mkt.toLowerCase()];
      if (!marketEntry) return false;
      const colors = marketEntry.Color || {};
      return Object.values(colors).some(sizes => Array.isArray(sizes) && sizes.length > 0);
    },
    lookupPrice: (v, prices) => {
      if (!prices) return null;
      if (prices[v.key] != null) return prices[v.key];
      const stripped = v.key.replace(/-/g, '');
      if (prices[stripped] != null) return prices[stripped];
      const aliases = {
        't-shirt':'tshirt','tank-top':'tanktop','triblend-t-shirt':'triblend',
        'crop-top':'croptop','boxy-t-shirt':'boxytee',
        'aop-sweatpants':'sweats','aop-union-suit':'onesie',
        'fleece-jacket':'fleece','fleece-hoodie':'fleece','aop-hoodie':'hoodie',
        'allover-t-shirt':'tshirt','allover-tank-top':'tanktop',
        'womens-t-shirt':'womens','swim-briefs':'swimsuit',
        'swim-trunks':'swimsuit','square-cut-trunks':'swimsuit',
        'cotton-button-shirt':'buttonshirt','long-sleeve-button-shirt':'buttonshirt',
        'cotton-long-sleeve-button-shirt':'buttonshirt',
        'folding-fans':'handfan','pet-shirt':'pets','pet-hoodie':'pets','tote-bag':'tote'
      };
      if (aliases[v.key] && prices[aliases[v.key]] != null) return prices[aliases[v.key]];
      return null;
    },
    // Fires the Debut Edition order. Prefers the floating tray widget so the
    // customer stays on the current page and watches progress in the corner.
    // Falls back to the legacy loader page if the tray snippet isn't loaded.
    fireDebut: (variant, params) => {
      if (typeof window.swishDebutFire === 'function') {
        window.swishDebutFire({
          design: params.get('design'),
          designTitle: params.get('from_title'),
          target: params.get('target'),
          targetLabel: params.get('target_label'),
          fromId: params.get('from_id'),
          fromTitle: params.get('from_title'),
          mockup: params.get('mockup'),
          sourceHandle: (window.location.pathname.match(/^\/products\/([^\/?#]+)/) || [])[1] || null,
        });
        return;
      }
      location.href = `/pages/custom-product?${params.toString()}`;
    },
    showDebutConfirm: (variant, params, data) => {
      const modal = document.getElementById('swish-debut-confirm-modal');
      if (!modal) {
        Engine.fireDebut(variant, params);
        return;
      }
      document.body.appendChild(modal);
      const price = Engine.lookupPrice(variant, data.prices);
      const priceEl = document.getElementById('swish-debut-confirm-price');
      if (priceEl && price != null) priceEl.innerHTML = Engine.applyFormat(price * 100);
      const cleanName = (CONFIG.productTitle || '').replace(/\s*\([^)]*\)\s*$/, '').trim();
      const nameEl = document.getElementById('swish-debut-confirm-name');
      if (nameEl) nameEl.textContent = `${cleanName} (${variant.label})`;
      const prodDays = variant.delivery && variant.delivery.production;
      const deliveryEl = document.getElementById('swish-debut-confirm-delivery');
      if (deliveryEl) {
        deliveryEl.textContent = (prodDays && prodDays.min != null && prodDays.max != null)
          ? `Made to order. ${prodDays.min} to ${prodDays.max} business days to produce.`
          : 'Made to order';
      }
      const blurbEl = document.getElementById('swish-debut-confirm-blurb');
      if (blurbEl) {
        blurbEl.textContent = `First time we've made ${cleanName || 'this design'} as a ${variant.label}. Confirm and you're its first owner.`;
      }
      // Meta line is static copy, but if the modal element got re-used we make sure it's set.
      const metaEl = document.getElementById('swish-debut-confirm-meta');
      if (metaEl && !metaEl.textContent.trim()) {
        metaEl.textContent = `Usually under a minute. Up to 5 if the queue is busy. Keep browsing; we'll ping you in the corner when it's ready.`;
      }
      // Bulletproof close. Single most reliable approach across browsers: zero out the
      // visibility properties Safari is most likely to honor (visibility, opacity, display
      // — all !important), drop pointer-events so even a stuck paint can't capture clicks,
      // and stash the node inside a permanently-hidden parent so Safari can't optimize away
      // the change. Re-opening (showDebutConfirm) puts it back on body and resets these.
      const ensureStash = () => {
        let stash = document.getElementById('swish-modal-stash');
        if (!stash) {
          stash = document.createElement('div');
          stash.id = 'swish-modal-stash';
          stash.style.cssText = 'display:none !important;visibility:hidden !important;position:absolute;left:-9999px;top:-9999px;';
          stash.setAttribute('aria-hidden', 'true');
          document.body.appendChild(stash);
        }
        return stash;
      };
      const close = () => {
        try {
          modal.style.setProperty('display', 'none', 'important');
          modal.style.setProperty('visibility', 'hidden', 'important');
          modal.style.setProperty('opacity', '0', 'important');
          modal.style.setProperty('pointer-events', 'none', 'important');
          modal.setAttribute('aria-hidden', 'true');
          modal.setAttribute('hidden', 'hidden');
          ensureStash().appendChild(modal);
        } catch (_) {}
        document.body.style.overflow = '';
      };
      const go = () => {
        close();
        Engine.fireDebut(variant, params);
      };
      // Replace each button with a fresh clone so any zombie listeners from a previous open
      // are gone. Then attach ONE click handler per button — onclick + addEventListener('click')
      // both fire on the same click and produce duplicate requests, so we pick onclick (works
      // everywhere). A single fire-once latch per modal-open prevents double-fire in the rare
      // case of two click events landing in the same tick (e.g. iOS double-tap).
      const freshClone = (id) => {
        const el = document.getElementById(id);
        if (!el || !el.parentElement) return el;
        const clone = el.cloneNode(true);
        el.parentElement.replaceChild(clone, el);
        return clone;
      };
      const cancelBtn = freshClone('swish-debut-confirm-cancel');
      const goBtn     = freshClone('swish-debut-confirm-go');
      let alreadyFired = false;
      const fireOnce = (fn) => (e) => {
        if (alreadyFired) { if (e) { e.preventDefault(); e.stopPropagation(); } return; }
        alreadyFired = true;
        fn();
      };
      if (cancelBtn) cancelBtn.onclick = fireOnce(close);
      if (goBtn)     goBtn.onclick     = fireOnce(go);
      modal.onclick = (e) => {
        if (!document.getElementById('swish-debut-confirm-content').contains(e.target)) close();
      };
      // Reset all the !important properties a prior close may have set so block actually applies.
      modal.style.removeProperty('display');
      modal.style.removeProperty('visibility');
      modal.style.removeProperty('opacity');
      modal.style.removeProperty('pointer-events');
      modal.removeAttribute('aria-hidden');
      modal.removeAttribute('hidden');
      modal.style.display = 'block';
      document.body.style.overflow = 'hidden';
    },
    repositionTitle: () => {
      try {
        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        if (!isMobile) return;
        const media = document.querySelector('.product .product-media, .product #product-media');
        if (!media) return;
        const parent = media.parentElement;
        if (!parent) return;
        ['.product-info__labels', '.product-info__title', '.product-info__price'].forEach(sel => {
          const el = document.querySelector(sel);
          if (el) parent.insertBefore(el, media);
        });
        const sezzle = document.querySelector('.sezzle-shopify-info-button, .sw-sezzle');
        if (sezzle) {
          const sezBlock = sezzle.closest('.product-info__block, .shopify-block') || sezzle;
          if (sezBlock && sezBlock !== parent) parent.insertBefore(sezBlock, media);
        }
      } catch (e) { /* non-fatal */ }
    },
    init: async () => {
      Engine.repositionTitle();
      try {
        const [menuRes, availRes] = await Promise.all([
          fetch(CONFIG.jsonUrl),
          fetch(CONFIG.availJsonUrl).catch(() => null)
        ]);
        const data = await menuRes.json();
        const availData = availRes ? await availRes.json().catch(() => null) : null;
        const mkt = Engine.getMkt();
        const key = (data.productTypeMappings && data.productTypeMappings[CONFIG.type]) || CONFIG.type.toLowerCase().replace(/\s+/g, '-');
        const v = data.variants.find(item => item.key === key);
        if (!v) return;
        Engine.isPostCutoff = Engine.checkCutoff(mkt);
        if (CONFIG.isEnglish) Engine.initTimer(mkt, v, data);
        Engine.renderTrustRow(data, v, mkt);
        Engine.renderAA(data, key, mkt, availData);
      } catch (e) { console.error("Swish Engine Error:", e); }
    },
    initTimer: (mkt, v, data) => {
      // Daily Dozen: the lineup rotates every day at 3 AM ET. Override the production
      // cut-off countdown with one that mirrors the next drop and rotates this design out.
      const isDailyDozen = (v.key === 'gildan-softstyle-tee') || (CONFIG.type === 'Daily Dozen');
      if (isDailyDozen) {
        const lbl = document.getElementById('sw-urgency-label');
        if (lbl) lbl.innerHTML = `Vanishes in <span id="sw-countdown" class="sw-digits"></span>`;
        const tt = document.getElementById('sw-timer-tooltip-text');
        if (tt) tt.innerText = `Get it while you can. This design leaves the lineup at the 3 AM ET drop and won't be buyable after that. Once it's gone, it's gone.`;
        const runDD = () => {
          const nyNow = new Date(new Date().toLocaleString("en-US", { timeZone: "America/New_York" }));
          const drop = new Date(nyNow);
          drop.setHours(3, 0, 0, 0);
          if (nyNow >= drop) drop.setDate(drop.getDate() + 1);
          const diff = drop - nyNow;
          const h_ = Math.floor(diff / 3600000).toString().padStart(2, '0');
          const m_ = Math.floor((diff % 3600000) / 60000).toString().padStart(2, '0');
          const s_ = Math.floor((diff % 60000) / 1000).toString().padStart(2, '0');
          const cdEl = document.getElementById('sw-countdown');
          if (cdEl) cdEl.innerText = `${h_}:${m_}:${s_}`;
          const el = document.getElementById('sw-urgency-inline');
          if (el) el.style.display = 'flex';
        };
        setInterval(runDD, 1000); runDD();
        return;
      }
      const originRaw = v.delivery && v.delivery.origin;
      const origin = (originRaw && (originRaw[mkt] || originRaw['US'])) || 'USA';
      let isCNYMode = false;
      let targetDate = null;
      if (origin === 'China') {
        const now = new Date();
        if (now <= CNY.seasonEnd) {
          const isCottonList = CNY.cottonKeys.includes(v.key);
          const activeCutoff = isCottonList ? CNY.cutoffCotton : CNY.cutoffPoly;
          const warningStart = new Date(activeCutoff);
          warningStart.setDate(warningStart.getDate() - 4);
          if (now >= warningStart && now < activeCutoff) {
            isCNYMode = true; targetDate = activeCutoff;
            const lbl = document.getElementById('sw-urgency-label');
            if (lbl) lbl.innerHTML = `Cut-off before factory break in <span id="sw-countdown" class="sw-digits"></span>`;
            const tt = document.getElementById('sw-timer-tooltip-text');
            if (tt) tt.innerText = `This product is imported from overseas and many suppliers close for the Lunar New Year.`;
          }
        }
      }
      const run = () => {
        const h = { 'US':'America/Los_Angeles', 'CA':'America/Los_Angeles', 'UK':'Europe/London', 'EU':'Europe/Riga', 'AU':'Australia/Brisbane' };
        const tz = h[mkt] || h['US'];
        const now = new Date();
        const hubTime = new Date(now.toLocaleString("en-US", {timeZone: tz}));
        let cutoff;
        if (isCNYMode) {
          cutoff = new Date(targetDate);
        } else {
          cutoff = new Date(now.toLocaleString("en-US", {timeZone: tz}));
          cutoff.setHours(12, 0, 0, 0);
          if (hubTime > cutoff) cutoff.setDate(cutoff.getDate() + 1);
        }
        const diff = cutoff - hubTime;
        let displayStr = "00:00:00";
        if (diff > 0) {
          if (isCNYMode && diff > 86400000) {
            const d_ = Math.ceil(diff / 86400000); displayStr = `${d_} Days`;
          } else {
            const h_ = Math.floor(diff/3600000).toString().padStart(2,'0');
            const m_ = Math.floor((diff%3600000)/60000).toString().padStart(2,'0');
            const s_ = Math.floor((diff%60000)/1000).toString().padStart(2,'0');
            displayStr = `${h_}:${m_}:${s_}`;
          }
        } else {
          displayStr = "00:00:00";
          if (isCNYMode) location.reload();
        }
        const cdEl = document.getElementById('sw-countdown');
        if (cdEl) cdEl.innerText = displayStr;
        if (!isCNYMode) {
          const lbl = document.getElementById('sw-urgency-label');
          if (lbl) {
            lbl.innerHTML = Engine.isPostCutoff
              ? `Order in <span id="sw-countdown" class="sw-digits">${displayStr}</span> for tomorrow's batch`
              : `Order in <span id="sw-countdown" class="sw-digits">${displayStr}</span> for today's batch`;
          }
        }
        const el = document.getElementById('sw-urgency-inline');
        if (el) el.style.display = 'flex';
      };
      setInterval(run, 1000); run();
    },
    renderTrustRow: (data, v, mkt) => {
      const row = document.getElementById('sw-trust-row');
      if (!row) return;
      const originRaw = v.delivery && v.delivery.origin;
      const origin = (originRaw && (originRaw[mkt] || originRaw['US'])) || 'USA';
      const isLocal = (origin === { 'US':'USA', 'CA':'Canada', 'UK':'UK', 'EU':'EU', 'AU':'Australia' }[mkt]);
      const fmt = d => d.toLocaleString('en-US', { month: 'short', day: 'numeric' });
      const p = v.delivery.production;
      const ship = isLocal ? data.deliveryDefaults.shippingDays.same_country : data.deliveryDefaults.shippingDays.different_country;
      let baseDate = new Date();
      if (Engine.isPostCutoff) baseDate.setDate(baseDate.getDate() + 1);
      let truckIcon = CONFIG.cdn + "shipping-truck.svg";
      let arrivalStartDate = new Date(baseDate);
      const alertBox = document.getElementById('sw-cny-alert');
      if (alertBox) alertBox.style.display = 'none';
      if (origin === 'China' && baseDate <= CNY.seasonEnd) {
        const isCottonList = CNY.cottonKeys.includes(v.key);
        const activeCutoff = isCottonList ? CNY.cutoffCotton : CNY.cutoffPoly;
        const activeResume = isCottonList ? CNY.resumeCotton : CNY.resumePoly;
        if (baseDate > activeCutoff && alertBox) {
          alertBox.innerHTML = `<strong>&#x1F9E7; Holiday Production Pause</strong> This product is affected by the Lunar New Year closure and will resume production on ${activeResume.toLocaleDateString('en-US', {month:'short', day:'numeric'})}.`;
          alertBox.style.display = 'block';
          arrivalStartDate = new Date(activeResume);
          truckIcon = CONFIG.cdn + "late.svg";
        }
      }
      const totalDaysMin = parseInt(p.min) + parseInt(ship.min);
      const totalDaysMax = parseInt(p.max) + parseInt(ship.max);
      const arrivalMinStr = fmt(Engine.addBD(new Date(arrivalStartDate), totalDaysMin));
      const arrivalMaxStr = fmt(Engine.addBD(new Date(arrivalStartDate), totalDaysMax));
      const arrivalText = `${arrivalMinStr} &ndash; ${arrivalMaxStr}`;

      /* Carry the estimated-delivery range onto the cart line as a visible
         line item property so it shows in cart, checkout, and the order
         confirmation email. Frozen at add-to-cart: reflects the estimate the
         customer saw when they added the item. */
      try {
        const swForm = document.querySelector('form[action*="/cart/add"]');
        if (swForm) {
          let swProp = swForm.querySelector('input[name="properties[Estimated delivery]"]');
          if (!swProp) {
            swProp = document.createElement('input');
            swProp.type = 'hidden';
            swProp.name = 'properties[Estimated delivery]';
            swForm.appendChild(swProp);
          }
          swProp.value = `${arrivalMinStr} – ${arrivalMaxStr}`;
        }
      } catch (e) {}

      let fulfillmentLabel, fulfillmentIcon;
      if (isLocal) {
        fulfillmentIcon = CONFIG.cdn + (data.originIconMappings?.[mkt][origin.toLowerCase()] || "location-pin.svg");
        const countryMap = { 'US':'Ships from USA','CA':'Ships from Canada','UK':'Ships from UK','EU':'Ships from EU','AU':'Ships from Australia' };
        fulfillmentLabel = countryMap[mkt] || 'Ships Locally';
      } else {
        fulfillmentIcon = CONFIG.cdn + 'global.svg';
        let label = 'Duties Prepaid';
        if ((CONFIG.type || '').toLowerCase().indexOf('leather') !== -1 && (mkt === 'UK' || mkt === 'EU')) label = 'VAT & Duty May Apply';
        fulfillmentLabel = label;
      }

      /* EU GPSR — tooltip on fulfillment pill when mkt==='EU'.
         origin EU→Sinden, China→Europe Gateway, else→Swish Embassy Inc. */
      let gpsrHtml = '';
      if (mkt === 'EU') {
        let g;
        if (origin === 'EU') {
          g = {
            who: 'Sinden Ventures Limited',
            addr: 'AMarkou Evgenikou 11<br>Mesa Geitonia 4002 Limassol, Cyprus',
            email: 'gpsr@sindenventures.com'
          };
        } else if (origin === 'China') {
          g = {
            who: 'Europe Gateway International B.V.',
            addr: 'Kraijenhoffstraat 137 A<br>1018RG Amsterdam, Netherlands',
            email: 'info@euegi.nl'
          };
        } else {
          g = {
            who: 'Swish Embassy Inc.',
            addr: '2967 Dundas St. W. #1366<br>Toronto, ON M6P 1Z2, Canada',
            email: ''
          };
        }
        const emailLine = g.email
          ? `<br><a href="mailto:${g.email}">${g.email}</a>`
          : '';
        gpsrHtml = '<span class="sw-gpsr" tabindex="0" role="button" aria-label="EU product safety responsible person: ' + g.who + '">GPSR' +
          '<span class="sw-gpsr-tip" role="tooltip">' +
            '<strong>EU Responsible Person</strong>' +
            g.who + '<br>' + g.addr + emailLine +
          '</span>' +
        '</span>';
      }

      /* EU right-of-withdrawal notice (Directive 2011/83/EU Art. 16(c) and (e)).
         Second chip beside GPSR on the fulfillment pill; reuses the sw-gpsr
         classes so the existing CSS and tooltip-positioning JS apply unchanged
         (the tooltip wiring below targets ALL .sw-gpsr badges in the row). */
      let withdrawalHtml = '';
      if (mkt === 'EU') {
        withdrawalHtml = '<span class="sw-gpsr" tabindex="0" role="button" aria-label="Notification for EU consumers: right of withdrawal">Returns' +
          '<span class="sw-gpsr-tip" role="tooltip">' +
            '<strong>Notification for EU consumers</strong>' +
            'According to Article 16(c) and (e) of the Directive 2011/83/EU of the European Parliament and of the Council of 25 October 2011 on consumer rights, the right of withdrawal may not be provided for:' +
            '<br>1. the supply of goods that are made to the consumer\'s specifications or are clearly personalized;' +
            '<br>2. sealed goods which were unsealed after delivery and thus aren\'t suitable for return due to health protection or hygiene reasons,' +
            '<br>therefore Swish Embassy reserves rights to refuse returns at its sole discretion.' +
          '</span>' +
        '</span>';
      }

      const ratingEl = document.getElementById('jdgm-rating');
      const reviewsEl = document.getElementById('jdgm-reviews');
      const productRating = ratingEl ? parseFloat(ratingEl.value) : 0;
      const productReviewCount = reviewsEl ? parseInt(reviewsEl.value, 10) : 0;
      // Brand-level fallback so the star pill ALWAYS shows, even on fresh products
      // Source: https://app.judge.me/reviews/stores/swishembassy
      const BRAND_RATING = 4.9;
      const BRAND_REVIEWS = 2400;
      const useProductReviews = (productReviewCount > 0 && productRating > 0);
      const displayRating = useProductReviews ? productRating : BRAND_RATING;
      const ratingHref = '/pages/reviews';

      const pills = [];
      pills.push(`<span class="sw-pill sw-pill--green"><img src="${truckIcon}" alt=""> ${arrivalText}</span>`);
      pills.push(`<span class="sw-pill"><img src="${fulfillmentIcon}" alt=""> ${fulfillmentLabel}${gpsrHtml}${withdrawalHtml}</span>`);
      pills.push(`<a class="sw-pill sw-pill--link" href="${ratingHref}" aria-label="${useProductReviews ? productReviewCount + ' reviews' : 'Brand rating'}">&#9733; ${displayRating.toFixed(1)}<span style="color:#94a3b8;font-weight:500;">/5</span></a>`);
      if (v.fit) {
        const rulerSvg = '<svg class="sw-pill-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21.3 8.7L8.7 21.3a2.4 2.4 0 0 1-3.4 0L2.7 18.7a2.4 2.4 0 0 1 0-3.4L15.3 2.7a2.4 2.4 0 0 1 3.4 0l2.6 2.6a2.4 2.4 0 0 1 0 3.4Z"/><path d="m7.5 10.5 2 2"/><path d="m10.5 7.5 2 2"/><path d="m13.5 4.5 2 2"/><path d="m4.5 13.5 2 2"/></svg>';
        pills.push(`<button type="button" class="sw-pill sw-pill--link sw-fit-trigger" data-open="size-modal" aria-label="Open size chart">${rulerSvg} Fit: ${v.fit} <span class="sw-pill-chevron" aria-hidden="true">&rsaquo;</span></button>`);
      }
      row.innerHTML = pills.join('');
      row.style.display = 'grid';

      /* GPSR tooltip: position:fixed, JS-anchored to badge rect.
         Flips below + arrow (.is-below) when no room above.
         Stays open between badge↔tooltip so email link is clickable. */
      try {
        var badges = row.querySelectorAll('.sw-gpsr');
        badges.forEach(function(badge) {
          var tip = badge.querySelector('.sw-gpsr-tip');
          if (!tip) return;
          var hoverTimer = null;
          function position() {
            var b = badge.getBoundingClientRect();
            var tipRect = tip.getBoundingClientRect();
            var tipW = tipRect.width || 240;
            var tipH = tipRect.height || 90;
            var margin = 10;
            // Try above first; fall back below if it'd clip the top of the viewport.
            var above = b.top - tipH - margin;
            var below = b.bottom + margin;
            var top = above >= 8 ? above : below;
            badge.classList.toggle('is-below', top === below);
            // Horizontally center over the badge, clamped to viewport edges.
            var left = b.left + (b.width / 2) - (tipW / 2);
            left = Math.max(8, Math.min(left, window.innerWidth - tipW - 8));
            tip.style.top = top + 'px';
            tip.style.left = left + 'px';
            // Adjust arrow x so it still points at the badge after clamping.
            var arrowX = (b.left + b.width / 2) - left;
            arrowX = Math.max(12, Math.min(arrowX, tipW - 12));
            tip.style.setProperty('--arrow-x', arrowX + 'px');
          }
          function open() {
            clearTimeout(hoverTimer);
            badge.classList.add('is-open');
            position();
          }
          function close() {
            hoverTimer = setTimeout(function() { badge.classList.remove('is-open'); }, 150);
          }
          badge.addEventListener('mouseenter', open);
          badge.addEventListener('mouseleave', close);
          badge.addEventListener('focus', open);
          badge.addEventListener('blur', close);
          tip.addEventListener('mouseenter', open);
          tip.addEventListener('mouseleave', close);
        });
      } catch (e) { /* no-op — tooltip is a nice-to-have, never block the pill render */ }
    },
    renderAA: async (data, curKey, mkt, availData) => {
      const grid = document.getElementById('sw-aa-grid');
      const section = document.getElementById('sw-aa-section');
      const bar = document.getElementById('sw-aa-bar');
      const barThumbs = document.getElementById('sw-aa-bar-thumbs');
      const barCount = document.getElementById('sw-aa-bar-count');
      const modal = document.getElementById('swish-styles-modal');
      const modalList = document.getElementById('styles-popup-list');
      if (!grid || !section || !modal || !modalList) return;
      document.body.appendChild(modal);

      const filtered = data.variants.filter(v => v.key !== curKey && v.hidden_on_alternates !== true);
      let base = CONFIG.handle;
      [...data.variants].sort((a,b)=>(b.suffix||'').length-(a.suffix||'').length).forEach(vr => {
        if (vr.suffix && base.endsWith(vr.suffix)) base = base.replace(vr.suffix, '');
      });

      // Base t-shirt gate: a design with no flat base tee (e.g. an all-over-print pattern such as
      // hint-of-floral-polo) has no artwork that can transfer onto other garments, so it can't be
      // debuted. `base` is the canonical t-shirt handle (the t-shirt variant has an empty suffix).
      // If that product doesn't exist, suppress every "Be the first!" option. Real alternates that
      // DO exist still render normally.
      let baseExists = false;
      try {
        const br = await fetch(`/products/${base}.js`, { cache: 'no-store' });
        baseExists = br.ok;
      } catch (e) { baseExists = false; }

      const items = (await Promise.all(filtered.map(async (v) => {
        const url = `/products/${base}${v.suffix || ''}`;
        let product = null;
        try {
          const r = await fetch(url + '.js');
          if (r.ok) product = await r.json();
        } catch (e) { /* swallowed */ }
        if (product && product.featured_image != null) {
          return { v, url, kind: 'real', product };
        }
        if (!baseExists) return null;            // no flat base design → never offer a debut
        if (data.settings && data.settings.customRequestEnabled === false) return null;
        if (!v.enable_custom_request) return null;
        if (!Engine.isAvailableForRequest(v, mkt, availData)) return null;
        return { v, url, kind: 'debut', product: null };
      }))).filter(Boolean);

      if (items.length === 0) return;

      // Data-driven ordering. Reads `data.shelfRanking` (volume/margin/seasonal/newTypeBoost/
      // upgradeBoost) + `data.profitability.margins` from the live config. Keeps instant (real)
      // alternates ahead of "Be the first!" debuts, then orders each group by score.
      const RANK = data.shelfRanking || {};
      const MARGINS = (data.profitability && data.profitability.margins) || {};
      const nowMonth = (new Date()).getMonth() + 1;
      function shelfScore(v) {
        let s = (RANK.volume && RANK.volume[v.key]) || 1;            // demand: trailing-365d order counts
        s *= 1 + (RANK.marginWeight || 0) * (MARGINS[v.key] || 0);   // margin nudge
        if (RANK.newTypeBoost && RANK.newTypeBoost[v.key]) s *= RANK.newTypeBoost[v.key]; // lift under-exposed new types
        for (const season of Object.values(RANK.seasonal || {})) {   // seasonal float (summer/winter)
          if (season.months && season.months.indexOf(nowMonth) !== -1 && season.boost && season.boost[v.key]) {
            s *= season.boost[v.key];
          }
        }
        if (RANK.upgradeBoost && (RANK.upgradeBoost.from || []).indexOf(curKey) !== -1   // float premium garments on a basic-tee PDP
            && RANK.upgradeBoost.types && RANK.upgradeBoost.types[v.key]) {
          s *= RANK.upgradeBoost.types[v.key];
        }
        return s;
      }
      items.sort((a, b) => {
        if (a.kind !== b.kind) return a.kind === 'real' ? -1 : 1;   // instant alternates before "Be the first!"
        return shelfScore(b.v) - shelfScore(a.v);                   // then highest score first
      });

      const TOP = 3;
      const topItems = items.slice(0, TOP);
      const restItems = items.slice(TOP);

      const buildCard = (item) => {
        const { v, url, kind, product } = item;
        const card = document.createElement('a');
        card.className = 'sw-aa-card';
        card.id = `sw-aa-card-${v.key}`;
        card.href = url;
        const fallbackIcon = CONFIG.cdn + (data.icons[v.icon] || v.icon);
        const realImg = (kind === 'real' && product.featured_image)
          ? product.featured_image.replace(/\.(jpg|png|jpeg|gif)/, '_200x200_crop_center.$1')
          : null;
        card.innerHTML = `
          <div class="sw-aa-img"><img${realImg ? '' : ' class="icon"'} src="${realImg || fallbackIcon}" alt="${v.label}"></div>
          <div class="sw-aa-label">${v.label}</div>
          ${kind === 'real'
            ? `<div class="sw-aa-price">${Engine.applyFormat(product.price)}</div>`
            : `<div class="sw-aa-bef">Be the first!</div>`}
        `;
        if (kind === 'real' && product.price > CONFIG.currentPrice) {
          const diffEl = document.createElement('div');
          diffEl.className = 'sw-aa-diff';
          diffEl.innerHTML = `+ ${Engine.applyFormat(product.price - CONFIG.currentPrice, true)}`;
          card.insertBefore(diffEl, card.querySelector('.sw-aa-price'));
        }
        if (kind === 'debut') {
          const params = new URLSearchParams({
            design: base, from: CONFIG.handle, from_id: CONFIG.productId,
            from_title: CONFIG.productTitle, target: v.key, target_label: v.label,
            mockup: CONFIG.featuredImage || ''
          });
          card.removeAttribute('href');
          card.onclick = (e) => { e.preventDefault(); Engine.showDebutConfirm(v, params, data); };
        }
        return card;
      };

      grid.innerHTML = '';
      topItems.forEach(item => grid.appendChild(buildCard(item)));

      if (restItems.length > 0 && bar && barThumbs && barCount) {
        const MAX_BAR_THUMBS = 5;
        const thumbItems = restItems.slice(0, MAX_BAR_THUMBS);
        barThumbs.innerHTML = '';
        thumbItems.forEach(item => {
          const thumb = document.createElement('div');
          thumb.className = 'sw-aa-bar-thumb';
          const fallbackIcon = CONFIG.cdn + (data.icons[item.v.icon] || item.v.icon);
          const realImg = (item.kind === 'real' && item.product.featured_image)
            ? item.product.featured_image.replace(/\.(jpg|png|jpeg|gif)/, '_64x64_crop_center.$1')
            : null;
          thumb.innerHTML = realImg
            ? `<img src="${realImg}" alt="">`
            : `<img class="icon" src="${fallbackIcon}" alt="">`;
          barThumbs.appendChild(thumb);
        });
        barCount.textContent = restItems.length === 1 ? '1 more' : `${restItems.length} more`;
        bar.style.display = 'flex';
        bar.onclick = () => { modal.style.display = 'block'; document.body.style.overflow = 'hidden'; };
      }

      const containers = {};
      const fragment = document.createDocumentFragment();
      [...new Set(items.map(i => i.v.category || 'Specialty'))].forEach(cat => {
        const div = document.createElement('div');
        div.innerHTML = `<div class="sw-cat-header">${cat}</div><div class="sw-cat-items" style="display:flex; flex-direction:column; gap:12px;"></div>`;
        fragment.appendChild(div); containers[cat] = div;
      });
      modalList.innerHTML = '';
      modalList.appendChild(fragment);
      items.forEach(item => {
        const { v, url, kind, product } = item;
        const fallbackIcon = CONFIG.cdn + (data.icons[v.icon] || v.icon);
        const realImg = (kind === 'real' && product.featured_image)
          ? product.featured_image.replace(/\.(jpg|png|jpeg|gif)/, '_100x100_crop_center.$1')
          : null;
        const row = document.createElement('div');
        row.className = "sw-prod-row";
        row.innerHTML = `<div style="width:48px;height:48px;flex-shrink:0;background:#f9fafb;border-radius:10px;overflow:hidden;display:flex;align-items:center;justify-content:center;"><img src="${realImg || fallbackIcon}" style="width:100%;height:100%;object-fit:${realImg ? 'cover' : 'contain'};"></div><div style="flex-grow:1;min-width:0;"><p style="font-weight:800;font-size:0.95em;margin:0;color:#1e293b;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${v.label}</p><p class="sw-blurb-text">${v.blurb || ''}</p><div class="sw-upgrade-spot" style="font-size:0.75em;color:#0073e6;font-weight:800;margin-top:2px;"></div></div><div class="sw-price-spot"></div>`;
        if (kind === 'real') {
          row.onclick = () => location.href = url;
          row.querySelector('.sw-price-spot').innerHTML = Engine.applyFormat(product.price);
          if (product.price > CONFIG.currentPrice) {
            row.querySelector('.sw-upgrade-spot').innerHTML = `+ ${Engine.applyFormat(product.price - CONFIG.currentPrice, true)}`;
          }
        } else {
          const params = new URLSearchParams({
            design: base, from: CONFIG.handle, from_id: CONFIG.productId,
            from_title: CONFIG.productTitle, target: v.key, target_label: v.label,
            mockup: CONFIG.featuredImage || ''
          });
          row.onclick = () => Engine.showDebutConfirm(v, params, data);
          const price = Engine.lookupPrice(v, data.prices);
          row.querySelector('.sw-price-spot').innerHTML = (price != null)
            ? Engine.applyFormat(price * 100)
            : '<span style="color:#94a3b8;font-size:0.85em;">&mdash;</span>';
          const requestCents = (price != null) ? price * 100 : null;
          const showDiff = (requestCents != null && requestCents > CONFIG.currentPrice);
          const diffLabel = showDiff ? `+ ${Engine.applyFormat(requestCents - CONFIG.currentPrice, true)} &middot; ` : '';
          row.querySelector('.sw-upgrade-spot').innerHTML = `<span style="color:#E8345E;font-weight:700;">${diffLabel}Be the first!</span>`;
          row.style.order = '2';
        }
        containers[v.category || 'Specialty'].querySelector('.sw-cat-items').appendChild(row);
      });

      section.style.display = 'block';

      const closeBtn = document.getElementById('close-styles-modal');
      if (closeBtn) closeBtn.onclick = () => { modal.style.display = 'none'; document.body.style.overflow = ''; };
      modal.onclick = (e) => {
        if (!document.getElementById('swish-modal-content').contains(e.target)) {
          modal.style.display = 'none'; document.body.style.overflow = '';
        }
      };
    }
  };
  Engine.init();

  // Fit pill &mdash; trigger the theme's existing Size Chart modal-opener.
  // The theme renders a <modal-opener data-modal="modal-pop_up_XXX"> button wrapping
  // the Size Chart pop-up block. We locate it by button text and forward the click,
  // so the theme handles focus, scroll lock, and close-on-overlay natively.
  (function wireFitTrigger(){
    const findThemeOpener = () => {
      const openers = document.querySelectorAll('modal-opener');
      for (const o of openers) {
        const btn = o.querySelector('button, a');
        const t = ((btn && btn.textContent) || '').trim().toLowerCase();
        if (t === 'size chart' || t === 'size guide' || t.includes('size chart') || t.includes('size guide')) {
          return btn;
        }
      }
      // Fallback &mdash; first modal-dialog containing a "size" heading
      const dlgs = document.querySelectorAll('modal-dialog');
      for (const d of dlgs) {
        if (/size\s*(chart|guide)/i.test(d.textContent || '')) {
          const id = d.id;
          const opener = document.querySelector(`modal-opener[data-modal="${id}"] button, modal-opener[data-modal="${id}"] a`);
          if (opener) return opener;
        }
      }
      return null;
    };
    document.addEventListener('click', (e) => {
      const t = e.target.closest && e.target.closest('[data-open="size-modal"]');
      if (!t) return;
      e.preventDefault();
      const opener = findThemeOpener();
      if (opener) { opener.click(); return; }
      // Final fallback: navigate to the page if the theme block has been removed
      window.location.href = '/pages/size-chart';
    });
  })();
})();
